import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { trackSubscribed } from './tracking';
import { useSearchSetParams } from './useSearchSetParams';
import { SaveSearchContainer, useSaveSearchEvents, TOnSubmitSaveSearchParams } from '../../../packages/SaveSearchModal';

const handleOnSubscribed = ({ frequency, subscribeToNews }: TOnSubmitSaveSearchParams) => {
  trackSubscribed({ frequency, subscribeToNews });

  /* istanbul ignore next */
  if (window.__reloadHeader__) {
    window.__reloadHeader__();
  }
};

export const SubscribeButtonContainer: React.FC = () => {
  const handleClick = useSearchSetParams();

  useSaveSearchEvents(handleOnSubscribed);

  return (
    <>
      <Button data-name="SubscribeButtonContainer" size="XS" theme="fill_secondary" onClick={handleClick}>
        Подписаться на дом
      </Button>
      <SaveSearchContainer />
    </>
  );
};

SubscribeButtonContainer.displayName = 'SubscribeButtonContainer';
